import { fetchWrapper } from 'helpers';

export const getPrivacyPolicy = () => {
  const url = `${process.env.REACT_APP_API_URL}/privacy-policy`;
  return fetchWrapper(url);
};
